// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__12XHY","container":"Footer_container__2ugEC","link":"Footer_link__1alL8"};